import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "QuantitativeFeedback"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M6.5 14.6111V12.5H8V14.6111L6.5 14.6111zM9.65002 10.3889V14.6111H11.15V10.3889H9.65002zM12.7999 14.6111V8.27779H14.2999V14.6111H12.7999zM15.9501 6.16666V14.6111L17.4501 14.6111V6.16666H15.9501z" }, null, -1);
const _hoisted_3 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 22L8.85 18.6471H2.5C1.94771 18.6471 1.5 18.1993 1.5 17.6471V4C1.5 3.44772 1.94772 3 2.5 3H21.5C22.0523 3 22.5 3.44772 22.5 4V17.6471C22.5 18.1993 22.0523 18.6471 21.5 18.6471H15.15L12 22ZM14.0568 17.62C14.3403 17.3182 14.7359 17.1471 15.15 17.1471H21V4.5H3V17.1471H8.85C9.26407 17.1471 9.65971 17.3182 9.94323 17.62L12 19.8093L14.0568 17.62Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/QuantitativeFeedback.vue"]]);
